import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectCallEndedStatus } from 'app/settings/selectors';
import { changeEndedStatus } from 'app/settings/slices';
import ExpirePassword from 'app/auth/components/ExpirePassword';

const mapStateToProps = ({ settings }) => ({
  endedStatus: selectCallEndedStatus({ settings }),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    changeEndedStatus,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ExpirePassword);
